import React, { useState } from 'react';
import { Routes } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import TopBar from '../TopBar';
import Footer from '../Footer';
import { Route } from 'react-router';
import Home from '../../routes/Home';
import SignUp from '../../routes/auth/SignUp';
import SignIn from '../../routes/auth/SignIn';
import ForgotPassword from '../../routes/auth/ForgotPassword';
import ResetPassword from '../../routes/auth/ResetPassword';
import { CartWrapper } from '../../routes/Cart';
import { CheckoutWrapper } from '../../routes/Checkout';
import { ConfirmationWrapper } from '../../routes/Confirmation';
import Orders from '../../routes/Orders';
import DirectSaleOrders from '../../routes/DirectSaleOrders';
import Azienda from '../../routes/Azienda';
import Negozio from '../../routes/Negozio';
import Ordina from '../../routes/Ordina';
import Contatti from '../../routes/Contatti';
import { RequireAuth } from './RequireAuth';
import { ShopModeDialog } from '../ShopModeDialog';
import { useShopModeInitialization } from '../../hooks';
import { setShopMode } from '../../redux/actions/shopMode.actions';
import { ShopMode } from '../../redux/types';
import { PrivacyPolicy } from '../../routes/legal/PrivacyPolicy';
import { CookiePolicy } from '../../routes/legal/CookiePolicy';
import { TermsAndConditions } from '../../routes/legal/TermsAndConditions';

const Main = styled.main`
  flex-grow: 1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas: 'topbar' 'main';

  .MuiAppBar-root {
    grid-area: topbar;
  }
  .MuiContainer-root {
    grid-area: main;
  }
`;

export const MainComponent = () => {
  const dispatch = useDispatch();
  const [initDialogOpen, setInitDialogOpen] = useState(false);

  useShopModeInitialization(() => setInitDialogOpen(true));

  const handleInitDialogConfirm = (mode: ShopMode) => {
    dispatch(setShopMode(mode));
    setInitDialogOpen(false);
  };

  return (
    <>
      <Main>
        <TopBar />

        <Routes>
          <Route path={'/'} element={<Home />} />
          <Route path={'/signup'} element={<SignUp />} />
          <Route path={'/signin'} element={<SignIn />} />
          <Route path={'/forgot-password'} element={<ForgotPassword />} />
          <Route path={'/reset-password'} element={<ResetPassword />} />
          <Route path={'/cart'} element={<CartWrapper />} />
          <Route
            path={'/checkout'}
            element={
              <RequireAuth>
                <CheckoutWrapper />
              </RequireAuth>
            }
          />
          <Route
            path={'/confirmation'}
            element={
              <RequireAuth>
                <ConfirmationWrapper />
              </RequireAuth>
            }
          />
          <Route
            path={'/orders'}
            element={
              <RequireAuth>
                <Orders />
              </RequireAuth>
            }
          />
          <Route
            path={'/online-orders'}
            element={
              <RequireAuth>
                <DirectSaleOrders />
              </RequireAuth>
            }
          />
          <Route path={'/azienda'} element={<Azienda />} />
          <Route path={'/negozio'} element={<Negozio />} />
          <Route path={'/ordina'} element={<Ordina />} />
          <Route path={'/contatti'} element={<Contatti />} />
          <Route path={'/privacy-policy'} element={<PrivacyPolicy />} />
          <Route path={'/cookie-policy'} element={<CookiePolicy />} />
          <Route path={'/termini-condizioni'} element={<TermsAndConditions />} />
        </Routes>
      </Main>
      <Footer />

      <ShopModeDialog open={initDialogOpen} onConfirm={handleInitDialogConfirm} initialMode={ShopMode.LocalDelivery} />
    </>
  );
};
